import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { get } from "@/lib/api";
import { PageLoader, PageHeader, EmptyState, Badge } from "@/components/common";
import { Users, Search } from "lucide-react";

export default function Students() {
  const nav = useNavigate();
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const { data, isLoading } = useQuery({ queryKey: ["admin-students", filter, q], queryFn: () => get(`/admin/students?filter=${filter}&q=${encodeURIComponent(q)}`) });

  return (
    <div>
      <PageHeader title="Student Management" subtitle="View, search & manage all students" />
      <div className="flex flex-wrap items-center gap-2 mb-5">
        <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-2 flex-1 min-w-[200px]"><Search className="h-4 w-4 text-slate-400" /><input value={q} onChange={(e) => setQ(e.target.value)} data-testid="student-search" placeholder="Name, email, mobile, ID..." className="bg-transparent outline-none text-sm flex-1" /></div>
        {[["all", "All"], ["active", "Active"], ["inactive", "Inactive"], ["new", "New (5d)"]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`student-filter-${k}`} className={`px-4 py-2 rounded-lg text-sm font-semibold ${filter === k ? "bg-indigo-800 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      {isLoading ? <PageLoader /> : !data?.length ? <EmptyState icon={Users} title="No students found" /> : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="text-left p-3">Name</th><th className="text-left p-3">Email</th><th className="text-left p-3">Mobile</th><th className="text-left p-3">Status</th><th className="text-left p-3">Joined</th></tr></thead>
            <tbody>{data.map((s) => (
              <tr key={s.id} onClick={() => nav(`/admin/students/${s.id}`)} data-testid={`student-row-${s.id}`} className="border-t border-slate-100 cursor-pointer hover:bg-slate-50">
                <td className="p-3 font-medium text-slate-800">{s.name} {s.is_new && <Badge tone="amber">New</Badge>}</td>
                <td className="p-3 text-slate-600">{s.email}</td><td className="p-3 text-slate-600">{s.mobile}</td>
                <td className="p-3">{s.is_paid_active ? <Badge tone="green">Active</Badge> : <Badge tone="slate">Inactive</Badge>}{!s.is_active && <Badge tone="red">Disabled</Badge>}</td>
                <td className="p-3 text-slate-500">{new Date(s.created_at).toLocaleDateString()}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
